// extracted by mini-css-extract-plugin
module.exports = {"DropdownItem":"MoreDropdown_DropdownItem__2E4UM"};